export default {
  black: `rgba(29,28,28,1)`,
  white: `rgba(255,255,255,1)`,
  veryLightGray: `rgba(248,248,248,1)`,
  lightGray: `rgba(233,234,235,1)`,
  medGray: `rgba(212,216,220,1)`,
  medDarkGray: `rgba(184,188,192,1)`,
  darkGray: `rgba(123,132,142,1)`,
  veryDarkGray: `rgba(86,94,105,1)`,
  ampEidVeryLightBlue: `rgba(245,250,253,1)`,
  ampEidLightBlue: `rgba(224,241,251,1)`,
  ampEidLightBlue2: `rgba(205,227,240,1)`,
  ampEidMedLightBlue: `rgba(149,203,235,1)`,
  ampEidMedBlue: `rgba(97,152,185,1)`,
  ampEidDarkBlue: `rgba(18,45,61,1)`,
  ampEidEvenDarkerBlue: `rgba(10,36,51,1)`,
  ampEidUltraDarkBlue: `rgb(10, 28, 40)`,
  link: `rgba(24,106,165,1)`,
  option1: `rgba(104,158,189,1)`,
  option2: `rgba(140,115,160,1)`,
  option3: `rgba(141,190,102,1)`,
  option4: `rgba(238,201,107,1)`,
  option5: `rgba(246,142,95,1)`,
  option6: `rgba(200,107,119,1)`,
  option7: `rgba(184,188,192,1)`,
  treatyColor: `rgba(173,218,138,1)`,
  option1Lighter: `rgba(184,216,235,1)`,
  option2Lighter: `rgba(219,204,232,1)`,
  option3Lighter: `rgba(199,225,178,1)`,
  option4Lighter: `rgba(248,229,179,1)`,
  option5Lighter: `rgba(244,218,207,1)`,
  option6Lighter: `rgba(223,186,191,1)`,
  blueButtonDefault: `linear-gradient(to bottom, rgba(69,128,162,0.271) 0%,rgba(69,128,162,0.271) 100%)`,
  blueButtonHover: `linear-gradient(to bottom, rgba(143,183,207,0.561) 0%,rgba(143,183,207,0.561) 100%)`,
  blueButtonDisabled: `linear-gradient(to bottom, rgba(212,216,220,0.832) 0%,rgba(212,216,220,0.832) 100%)`,
}
